import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import Container from "@saleor/components/Container";
import LanguageSwitch from "@saleor/components/LanguageSwitch";
import PageHeader from "@saleor/components/PageHeader";
import { LoginPopupTranslationFragment } from "@saleor/fragments/types/LoginPopupTranslationFragment";
import { commonMessages, sectionNames } from "@saleor/intl";
import { TranslationsEntitiesPageProps } from "@saleor/translations/types";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { LanguageCodeEnum } from "../../../types/globalTypes";
import TranslationFields from "../TranslationFields";

export interface TranslationsLoginPopupPageProps
  extends TranslationsEntitiesPageProps {
  loginPopup: LoginPopupTranslationFragment;
}

export const fieldNames = {
  title: "title",
  coupon: "coupon",
  Button: "Button",
  pcUrl: "pcUrl",
  mbUrl: "mbUrl",
  couponCode: "couponCode",
  subTitle: "subTitle"
};

const TranslationsLoginPopupPage: React.FC<TranslationsLoginPopupPageProps> = ({
  activeField,
  disabled,
  languageCode,
  languages,
  loginPopup,
  saveButtonState,
  onBack,
  onDiscard,
  onEdit,
  onLanguageChange,
  onSubmit
}) => {
  const intl = useIntl();

  return (
    <Container>
      <AppHeader onBack={onBack}>
        {intl.formatMessage(sectionNames.translations)}
      </AppHeader>
      <PageHeader
        title={intl.formatMessage(
          {
            defaultMessage:
              'Translation Login Popup "{loginPopupName}" - {languageCode}',
            description: "header"
          },
          {
            languageCode,
            loginPopupName: maybe(() => loginPopup.title, "...")
          }
        )}
      >
        <LanguageSwitch
          currentLanguage={LanguageCodeEnum[languageCode]}
          languages={languages}
          onLanguageChange={onLanguageChange}
        />
      </PageHeader>
      <TranslationFields
        activeField={activeField}
        disabled={disabled}
        initialState={true}
        title={intl.formatMessage(commonMessages.generalInformations)}
        fields={[
          {
            displayName: intl.formatMessage({
              defaultMessage: "Login Popup Title"
            }),
            name: fieldNames.title,
            translation: maybe(() =>
              loginPopup.translation ? loginPopup.translation.title : null
            ),
            type: "short" as "short",
            value: maybe(() => loginPopup.title)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Login Popup SubTitle"
            }),
            name: fieldNames.subTitle,
            translation: maybe(() =>
              loginPopup.translation ? loginPopup.translation.subTitle : null
            ),
            type: "short" as "short",
            value: maybe(() => loginPopup.subTitle)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Login Popup pcUrl",
              description: "loginPopup pcUrl"
            }),
            name: fieldNames.pcUrl,
            translation: maybe(() =>
              loginPopup.translation ? loginPopup.translation.pcUrl : null
            ),
            type: "short" as "short",
            value: maybe(() => loginPopup.pcUrl)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Login Popup mbUrl",
              description: "loginPopup mbUrl"
            }),
            name: fieldNames.mbUrl,
            translation: maybe(() =>
              loginPopup.translation ? loginPopup.translation.mbUrl : null
            ),
            type: "short" as "short",
            value: maybe(() => loginPopup.mbUrl)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Login Popup couponCode",
              description: "loginPopup content"
            }),
            name: fieldNames.couponCode,
            translation: maybe(() =>
              loginPopup.translation ? loginPopup.translation.couponCode : null
            ),
            type: "short" as "short",
            value: maybe(() => loginPopup.couponCode)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Login Popup couponCode",
              description: "loginPopup content"
            }),
            name: fieldNames.Button,
            translation: maybe(() =>
              loginPopup.translation ? loginPopup.translation.Button : null
            ),
            type: "short" as "short",
            value: maybe(() => loginPopup.Button)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Login Popup couponCode",
              description: "loginPopup content"
            }),
            name: fieldNames.coupon,
            translation: maybe(() =>
              loginPopup.translation ? loginPopup.translation.coupon : null
            ),
            type: "short" as "short",
            value: maybe(() => loginPopup.coupon)
          }
        ]}
        saveButtonState={saveButtonState}
        onEdit={onEdit}
        onDiscard={onDiscard}
        onSubmit={onSubmit}
      />
      <CardSpacer />
    </Container>
  );
};
TranslationsLoginPopupPage.displayName = "TranslationsLoginPopupPage";
export default TranslationsLoginPopupPage;
